import api from './client';

export const bridgeDaysService = {
    addBridgeDays: async (credentials) => {
        const response = await api.post('bridge-days', credentials);
        return response.data;
    },
    getAllBridgeDays: async () => {
        const response = await api.get('bridge-days');
        return response.data;
    },
    updateBridgeDays: async (id, credentials) => {
        const response = await api.put(`bridge-days/${id}`, credentials);
        return response.data;
    },
    deleteBridgeDays: async (id) => {
        const response = await api.delete(`bridge-days/${id}`);
        return response.data;
    },
};